module.exports = __webpack_public_path__ + "Roboto-Thin.7500519de3d82e33d158.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Thin.woff
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Thin.woff
// module chunks = 3